module.exports = __webpack_public_path__ + "static/media/3HayseedAQ5065.9943c89a.PNG";